export const routes = (prefix = `inpatients`) => [
    {
        path: `/${prefix}/nursing-notes/:patientID/:visitNO`,
        name: `${prefix}.nursing-notes.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.nursing-notes.create`,
                PageDescription: `Inpatient - Add nursing notes`,
            },
        },
    },
    {
        path: `/outpatient/nursing-notes/:patientID/:visitNO`,
        name: `outpatient.nursing-notes.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.nursing-notes.create`,
                PageDescription: `Inpatient - Add nursing notes`,
            },
        },
    },
    {
        path: `/${prefix}/nursing-notes/:patientID/:visitNO/:encounterID`,
        name: `${prefix}.nursing-notes.encounter.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.nursing-notes.create`,
                PageDescription: `Inpatient - Add nursing notes`,
            },
        },
    },
];